import {Navigate, useParams} from 'react-router-dom';
import {insightsSearch, markInsightsEntry, parseCallId} from './useInsightsDrawerParams';

export const LegacyTranscriptRedirect = () => {
    const {id} = useParams<{id: string}>();
    const callId = parseCallId(id ?? null);
    if (callId == null) return <Navigate to="/calls" replace/>;
    markInsightsEntry('legacy_link');
    return <Navigate to={`/calls${insightsSearch(callId)}`} replace/>;
};
